import { Flex } from '../../ui';
import {
  SignRightSideTitle,
  SignRightSideBody,
  SignRightSideFooter,
} from './atoms';

// Main container component
type SignRightSideProps = {
  children: React.ReactNode;
};

const SignRightSide = ({ children }: SignRightSideProps) => {
  return (
    <Flex align="center" justify="center" className="flex-1 bg-background p-8">
      <div className="min-w-96 space-y-8">{children}</div>
    </Flex>
  );
};

// Attach sub-components to main component
SignRightSide.Title = SignRightSideTitle;
SignRightSide.Body = SignRightSideBody;
SignRightSide.Footer = SignRightSideFooter;

export { SignRightSide };
